import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import Layout from '../components/layout/Layout';
import { Loader2, CheckCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CoachApplyPage() {
  const [f, setF] = useState({ name: '', email: '', phone: '', headline: '', expertise: '', years_experience: '', bio: '', why: '', linkedin: '' });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.email) return toast.error('Name and email are required');
    setBusy(true);
    try {
      await axios.post(`${API}/api/coaches/apply`, {
        ...f,
        expertise: f.expertise.split(',').map(s => s.trim()).filter(Boolean),
        years_experience: f.years_experience ? parseInt(f.years_experience) : null,
      });
      setDone(true);
    } catch (e) { toast.error(e.response?.data?.detail || 'Failed to submit'); } finally { setBusy(false); }
  };

  if (done) return (
    <Layout title="Application received">
      <div className="max-w-xl mx-auto px-6 py-20 text-center" data-testid="apply-success">
        <CheckCircle size={56} className="text-green-500 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-[#0A0F1C] mb-2">Application received!</h1>
        <p className="text-[#475569]">Thanks for applying to coach under DCA Enterprises. Our team will review your application and reach out by email.</p>
      </div>
    </Layout>
  );

  return (
    <Layout title="Apply to Coach">
      <div className="max-w-xl mx-auto px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-[#0A0F1C] mb-2">Apply to Coach with DCA</h1>
        <p className="text-[#475569] mb-8">Join our vetted roster of business strategists and entrepreneurship coaches.</p>
        <form onSubmit={submit} className="bg-white border border-[#E2E8F0] rounded-2xl p-6 space-y-3" data-testid="apply-form">
          <div className="grid sm:grid-cols-2 gap-3">
            <input className="px-3 py-2 border rounded text-sm" placeholder="Full name *" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} data-testid="apply-name" />
            <input className="px-3 py-2 border rounded text-sm" placeholder="Email *" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} data-testid="apply-email" />
            <input className="px-3 py-2 border rounded text-sm" placeholder="Phone" value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })} />
            <input type="number" min="0" className="px-3 py-2 border rounded text-sm" placeholder="Years of experience" value={f.years_experience} onChange={e => setF({ ...f, years_experience: e.target.value })} />
          </div>
          <input className="w-full px-3 py-2 border rounded text-sm" placeholder="Headline (e.g. Scaling 6-figure service businesses)" value={f.headline} onChange={e => setF({ ...f, headline: e.target.value })} />
          <input className="w-full px-3 py-2 border rounded text-sm" placeholder="Areas of expertise (comma separated)" value={f.expertise} onChange={e => setF({ ...f, expertise: e.target.value })} data-testid="apply-expertise" />
          <textarea className="w-full px-3 py-2 border rounded text-sm" rows={3} placeholder="Short bio" value={f.bio} onChange={e => setF({ ...f, bio: e.target.value })} />
          <textarea className="w-full px-3 py-2 border rounded text-sm" rows={3} placeholder="Why do you want to coach with DCA?" value={f.why} onChange={e => setF({ ...f, why: e.target.value })} />
          <input className="w-full px-3 py-2 border rounded text-sm" placeholder="LinkedIn URL (optional)" value={f.linkedin} onChange={e => setF({ ...f, linkedin: e.target.value })} />
          <button disabled={busy} className="btn-primary-orange text-sm w-full" data-testid="apply-submit">{busy ? <Loader2 size={16} className="animate-spin inline" /> : 'Submit Application'}</button>
        </form>
      </div>
    </Layout>
  );
}
